import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';
import MaskedInput from 'react-maskedinput';
import moment from 'moment';
import { t } from 'services/translation';

import './index.scss';

class Input extends React.Component {
  static displayName = 'Input';

  static propTypes = {
    id: PropTypes.string,
    name: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    placeholder: PropTypes.string,
    type: PropTypes.string,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func,
    value: PropTypes.string,
    className: PropTypes.string,
    errors: PropTypes.oneOfType([PropTypes.array, PropTypes.bool]),
    autoComplete: PropTypes.string,
  };

  static defaultProps = {
    placeholder: null,
    theme: 'Default',
    type: 'text',
    errors: [],
    className: '',
    autoComplete: 'off',
    onChange: () => {},
  };

  state = { defaultDate: null };

  componentDidMount() {
    // this is a workaround for autofill extensions that do not trigger change event when filling
    // the input value. the timeout will auto trigger the change at the end of the component lifecycle.
    // does not work with and thus filters by mask component version of Input.
    // (see imported <Input/> component for ref. )
    setTimeout(() => {
      if (
        this.refs.input &&
        !this.refs.input.mask &&
        this.refs.input.value != ''
      ) {
        this.props.onChange(this.props.name, this.refs.input.value, null);
      }
    }, 0);
  }

  onChangeProxy = (e) => {
    this.props.onChange(this.props.name, e.target.value, e);
  };

  _hasError = () => {
    return this.props.errors.length > 0;
  };

  _isAndroid = () => {
    return (
      window.mobileDetect && window.mobileDetect.ua.indexOf('Android') > -1
    );
  };

  _setDefaultAndroidDate = () => {
    // sets android date picker default to 21 years ago for less user scrolling.
    if (!this.state.defaultDate) {
      const defaultDate = moment().subtract(21, 'year').format('YYYY-MM-DD');
      this.setState({
        defaultDate,
      });
    }
  };

  _renderMask = () => {
    // is android
    if (this._isAndroid() && this.props.type === 'date') {
      let dateValue = this.props.value || this.state.defaultDate;
      if (dateValue && dateValue.indexOf('/') > -1) {
        // convert to native android date format
        const splitArray = dateValue.split('/');
        dateValue = `${splitArray[2]}-${splitArray[0]}-${splitArray[1]}`;
      }
      return (
        <input
          type="date"
          name={this.props.name}
          className={this.props.className}
          placeholder={this.props.placeholder}
          ref="input"
          value={dateValue}
          onClick={this._setDefaultAndroidDate}
          autoComplete="off"
          onChange={this.onChangeProxy}
          onFocus={this.props.onFocus}
          onBlur={this.props.onBlur}
          maxLength={this.props.maxLength}
        />
      );
    }
    // non android
    return (
      <MaskedInput
        mask={this.props.mask}
        pattern={this.props.pattern}
        placeholderChar=" "
        name={this.props.name}
        className={this.props.className}
        placeholder={this.props.placeholder}
        type={this.props.type}
        ref="input"
        value={this.props.value}
        autoComplete="off"
        onChange={this.onChangeProxy}
        onFocus={this.props.onFocus}
        onBlur={this.props.onBlur}
        maxLength={this.props.maxLength}
        data-testid={this.props['data-testid']}
      />
    );
  };

  render() {
    const { type } = this.props;
    const inputWrapperClasses = classnames(
      'ui',
      'input',
      `t-${this.props.theme}`,
      {
        error: this._hasError(),
        hidden: type === 'hidden',
      }
    );

    // refactor - dry up the props here
    return (
      <div className={inputWrapperClasses} ref="input_wrapper">
        {this.props.mask && this._renderMask()}
        {!this.props.mask && (
          <input
            id={this.props.id}
            name={this.props.name}
            disabled={this.props.disabled}
            placeholder={this.props.placeholder}
            className={this.props.className}
            type={type}
            ref="input"
            value={this.props.value}
            autoComplete={this.props.autoComplete}
            onChange={this.onChangeProxy}
            onFocus={this.props.onFocus}
            onBlur={this.props.onBlur}
            maxLength={this.props.maxLength}
            data-testid={this.props['data-testid']}
            role={this.props.role}
            aria-label={this.props.ariaLabel}
            aria-labelledby={this.props.ariaLabelledBy}
          />
        )}

        <span className="input-error">{this.props.errors[0] || ''}</span>
      </div>
    );
  }
}

export default Input;
